import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    displayModal: { form: false, confirmation: false },
    zeroState: false,
    selectedDsp: null,
    selectedRowId: null,
    deletedConfigId: null
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
